/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DummyErrors1, DummyErrors1Interface } from "../DummyErrors1";

const _abi = [
  {
    inputs: [],
    name: "AUTHORIZED_ADDRESS_MISMATCH_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "authorized",
        type: "address",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AuthorizedAddressMismatchError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    name: "BootstrapCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "DIVISION_BY_ZERO_ERROR",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DivisionByZeroError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        internalType: "address",
        name: "token2",
        type: "address",
      },
    ],
    name: "ERC1155TokenMismatchError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        internalType: "address",
        name: "token2",
        type: "address",
      },
    ],
    name: "ERC20TokenMismatchError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        internalType: "address",
        name: "token2",
        type: "address",
      },
    ],
    name: "ERC721TokenMismatchError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "remainingOrderAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "fillAmount",
        type: "uint128",
      },
    ],
    name: "ExceedsRemainingOrderAmount",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ILLEGAL_REENTRANCY_ERROR_SELECTOR_BYTES",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "INDEX_OUT_OF_BOUNDS_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "INVALID_BYTE_OPERATION_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "IllegalReentrancyError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "reentrancyFlags",
        type: "uint256",
      },
    ],
    name: "IllegalReentrancyError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "buyToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "boughtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buyAmount",
        type: "uint256",
      },
    ],
    name: "IncompleteFillBuyQuoteError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sellToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "soldAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sellAmount",
        type: "uint256",
      },
    ],
    name: "IncompleteFillSellQuoteError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "outputToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "outputTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minOutputTokenAmount",
        type: "uint256",
      },
    ],
    name: "IncompleteTransformERC20Error",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "IndexOutOfBoundsError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ethAttached",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ethNeeded",
        type: "uint256",
      },
    ],
    name: "InsufficientEthAttachedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ethAvailable",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "orderAmount",
        type: "uint256",
      },
    ],
    name: "InsufficientEthError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ethBalance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ethNeeded",
        type: "uint256",
      },
    ],
    name: "InsufficientProtocolFeeError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenBalance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensNeeded",
        type: "uint256",
      },
    ],
    name: "InsufficientTakerTokenError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "actual",
        type: "address",
      },
      {
        internalType: "address",
        name: "expected",
        type: "address",
      },
    ],
    name: "InvalidBootstrapCallerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType:
          "enum LibBytesRichErrorsV06_1.InvalidByteOperationErrorCodes",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "offset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "required",
        type: "uint256",
      },
    ],
    name: "InvalidByteOperationError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "actual",
        type: "address",
      },
      {
        internalType: "address",
        name: "expected",
        type: "address",
      },
    ],
    name: "InvalidDieCallerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "assetData",
        type: "bytes",
      },
    ],
    name: "InvalidERC20AssetDataError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "actualContext",
        type: "address",
      },
      {
        internalType: "address",
        name: "expectedContext",
        type: "address",
      },
    ],
    name: "InvalidExecutionContextError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mtxCount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "signatureCount",
        type: "uint256",
      },
    ],
    name: "InvalidMetaTransactionsArrayLengthsError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "InvalidSignerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "InvalidTakerFeeTokenError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType:
          "enum LibTransformERC20RichErrors1.InvalidTransformDataErrorCode",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "transformData",
        type: "bytes",
      },
    ],
    name: "InvalidTransformDataError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "providerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "sellAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "boughtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minBuyAmount",
        type: "uint256",
      },
    ],
    name: "LiquidityProviderIncompleteSellError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "executedBlockNumber",
        type: "uint256",
      },
    ],
    name: "MetaTransactionAlreadyExecutedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "returnData",
        type: "bytes",
      },
    ],
    name: "MetaTransactionCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expirationTime",
        type: "uint256",
      },
    ],
    name: "MetaTransactionExpiredError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "gasPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minGasPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxGasPrice",
        type: "uint256",
      },
    ],
    name: "MetaTransactionGasPriceError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "ethBalance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ethRequired",
        type: "uint256",
      },
    ],
    name: "MetaTransactionInsufficientEthError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "errData",
        type: "bytes",
      },
    ],
    name: "MetaTransactionInvalidSignatureError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
    ],
    name: "MetaTransactionUnsupportedFunctionError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "mtxHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "expectedSender",
        type: "address",
      },
    ],
    name: "MetaTransactionWrongSenderError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    name: "MigrateCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "sellOrderAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buyOrderAmount",
        type: "uint256",
      },
    ],
    name: "NegativeSpreadError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "outputToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "outputTokenLostAmount",
        type: "uint256",
      },
    ],
    name: "NegativeTransformERC20OutputError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
    ],
    name: "NotImplementedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "targetImpl",
        type: "address",
      },
    ],
    name: "NotInRollbackHistoryError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "address",
        name: "deployer",
        type: "address",
      },
    ],
    name: "OnlyCallableByDeployerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "OnlyCallableBySelfError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OnlyOwnerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "taker",
        type: "address",
      },
    ],
    name: "OnlyTakerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "orderStatus",
        type: "uint8",
      },
    ],
    name: "OrderNotFillableError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ethSpent",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ethAvailable",
        type: "uint256",
      },
    ],
    name: "OverspentEthError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "propertyValidator",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "propertyData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "PropertyValidationFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ROUNDING_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "numerator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "denominator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "target",
        type: "uint256",
      },
    ],
    name: "RoundingError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "SENDER_NOT_AUTHORIZED_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STANDARD_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "sellOrderFees",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "spread",
        type: "uint256",
      },
    ],
    name: "SellOrderFeesExceedSpreadError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "SenderNotAuthorizedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType:
          "enum LibSignatureRichErrors1.SignatureValidationErrorCodes",
        name: "code",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "signerAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "SignatureValidationError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType:
          "enum LibSignatureRichErrors1.SignatureValidationErrorCodes",
        name: "code",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
    ],
    name: "SignatureValidationError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "StandardError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "TARGET_ALREADY_AUTHORIZED_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TARGET_NOT_AUTHORIZED_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "TargetAlreadyAuthorizedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "TargetNotAuthorizedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "orderTokenId",
        type: "uint256",
      },
    ],
    name: "TokenIdMismatchError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "TransferOwnerToZeroError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "transformer",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "transformerData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    name: "TransformerFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "UINT256_BINOP_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UINT256_DOWNCAST_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum LibSafeMathRichErrorsV06_1.BinOpErrorCodes",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "Uint256BinOpError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum LibSafeMathRichErrorsV06_1.DowncastErrorCodes",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
    ],
    name: "Uint256DowncastError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "wallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "callTarget",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "callValue",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "WalletExecuteCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "wallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "callTarget",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "WalletExecuteDelegateCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ZERO_CANT_BE_AUTHORIZED_ERROR_BYTES",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ZeroCantBeAuthorizedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "rrevert",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DummyErrors1__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DummyErrors1> {
    return super.deploy(overrides || {}) as Promise<DummyErrors1>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DummyErrors1 {
    return super.attach(address) as DummyErrors1;
  }
  connect(signer: Signer): DummyErrors1__factory {
    return super.connect(signer) as DummyErrors1__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DummyErrors1Interface {
    return new utils.Interface(_abi) as DummyErrors1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DummyErrors1 {
    return new Contract(address, _abi, signerOrProvider) as DummyErrors1;
  }
}
